import type { IChannel } from '@shiftsmartinc/shiftsmart-types';

import React from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';
import { Button, Image } from 'semantic-ui-react';

import { getSizeIncrement } from '#/shared/components/utils/Avatar';
import GroupAvatar from '#/shared/components/utils/GroupAvatar';

export const ChannelAvatar = observer(({ channel }: { channel: IChannel }) => {
  const channelType = _.get(channel, 'channelType.category');

  const channelImage = channel.channelImage;

  let worker = {};
  if (channelType === 'one-on-one') {
    worker = _.find(channel.users, { userType: 'worker' });
  }

  const imageURL = !_.isEmpty(worker) ? worker.imageURL : channelImage;

  const users = formatUsersForAvatar(channel);

  return (
    <div className="w-100 h-100 relative">
      {imageURL ? (
        // TODO refactor and use UserImage component
        <SimpleAvatar imageURL={imageURL} />
      ) : (
        <GroupAvatar
          overrideStyles={{ backgroundColor: 'var(--bgLightBlue)' }}
          users={users}
        />
      )}
    </div>
  );
});

ChannelAvatar.displayName = 'ChannelAvatar';
export default ChannelAvatar;

function formatUsersForAvatar(channel) {
  return _(channel.users)
    .filter(
      (u) =>
        _.get(channel, 'channelType.category', '') === 'internal' ||
        /worker|consumer|vendor/.test(u.userType),
    )
    .sortBy((u) => {
      switch (u.userType) {
        case 'consumer':
          return `0${u.displayName}`;
        case 'vendor':
          return `1${u.displayName}`;
        case 'worker':
          return `2${u.displayName}`;
        case 'employer':
          return '4';
        case 'admin':
          return '10';
        default:
          return '3';
      }
    })
    .map((user) => ({
      displayName: user.displayName,
      profileImageURL: user.imageURL,
      uuid: user.uuid,
    }))
    .uniqBy('uuid')
    .value();
}

const defaultProfilePic = '/static/img/defaultProfilePic.png';
const SimpleAvatar = observer(
  ({ imageURL, className = 'w-100 h-100', imgStyle }) =>
    _.isEmpty(imageURL) || imageURL === defaultProfilePic ? (
      <div className={className}>
        <Button
          circular={true}
          color="blue"
          compact={true}
          icon="user"
          size={getSizeIncrement(className)}
        />
      </div>
    ) : (
      <Image
        alt="avatar"
        circular={true}
        className={className}
        src={imageURL}
        style={imgStyle}
      />
    ),
);

export { SimpleAvatar };
